import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogueBloc } from '@kp/dialogue/dialogue.bloc';
import { DialogueDataStatus, DialogueStatus, DialogueStatusData } from '@kp/dialogue/models/dialogue-data-status.model';
import { DAILY_REFLECTION_KEYS, DialogueLogicKey } from '@kp/dialogue/models/dialogue.model';
import { DataStatus, Status } from '@ktypes/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-dialogue-status',
  templateUrl: './dialogue-status.component.html',
  styleUrls: ['./dialogue-status.component.scss'],
})
export class DialogueStatusComponent implements OnInit, OnDestroy {
  @Input() dialogueKey: DialogueLogicKey;
  @Input() returnUrl: string;

  private _destroy$ = new Subject<void>();
  dailyReflectionKeys = DAILY_REFLECTION_KEYS;
  dialogueStatusData: DialogueStatusData;
  dataStatus: DataStatus<DialogueDataStatus>;
  dialogueLogicKey = DialogueLogicKey;
  dialogueStatus = DialogueStatus;
  status = Status;

  constructor(private _activatedRoute: ActivatedRoute, private _dialogueBloc: DialogueBloc) {}

  ngOnInit(): void {
    if (!this.dialogueKey) {
      this.dialogueKey = this._activatedRoute.snapshot.queryParams.logicKey as DialogueLogicKey;
    }
    if (!this.returnUrl) {
      this.returnUrl = this._activatedRoute.snapshot.queryParams.returnUrl;
    }

    if (this.dialogueKey) {
      // clear the dialogue if in error state
      this._dialogueBloc.clearDialogueStreamsIfError(true, true, this.dialogueKey);
    }

    this._dialogueBloc.dialogueStatus$.pipe(takeUntil(this._destroy$)).subscribe((dataStatus) => {
      this.dataStatus = dataStatus;
      this.dialogueStatusData = this.dataStatus?.data?.data;
      if (
        !this.dataStatus ||
        (this.dataStatus?.status === Status.done && this.dataStatus?.data?.logicKey !== this.dialogueKey)
      ) {
        this._dialogueBloc.getDialogueStatus(this.dialogueKey);
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
